import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_SENDBIRD_SESSION_TOKEN } from '@/shared/mutations';
import SentryService from '@/services/sentry/Sentry.service';
import { MutationResult } from '@/shared/types/generated';

export function useSendbirdToken() {
  const [createSendbirdToken, { loading: isLoadingSendbirdToken }] =
    useMutation<MutationResult<'createSendbirdSessionToken'>>(
      CREATE_SENDBIRD_SESSION_TOKEN,
      {
        onError(err) {
          SentryService.captureError('Failed to fetch Sendbird token', err);
        },
      },
    );

  const fetchSendbirdSessionToken = useCallback(async (): Promise<string> => {
    try {
      const { data } = await createSendbirdToken();
      const token = data?.createSendbirdSessionToken.sessionToken;

      if (!token) throw new Error('No Sendbird token returned');
      return token;
    } catch (error) {
      SentryService.captureError('Failed to fetch Sendbird token', error);
      throw error;
    }
  }, [createSendbirdToken]);

  return {
    fetchSendbirdSessionToken,
    isLoadingSendbirdToken,
  };
}

export default useSendbirdToken;
